import { render, staticRenderFns } from "./molecularTypingIndex.vue?vue&type=template&id=0f71a7b4&scoped=true"
import script from "./molecularTypingIndex.vue?vue&type=script&lang=js"
export * from "./molecularTypingIndex.vue?vue&type=script&lang=js"
import style0 from "./molecularTypingIndex.vue?vue&type=style&index=0&id=0f71a7b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f71a7b4",
  null
  
)

export default component.exports